"use strict";
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveDown = exports.moveUp = void 0;
var move = function (array, index, delta) {
    var newIndex = index + delta;
    if (newIndex < 0 || newIndex >= array.length) {
        return;
    } // Already at the top or bottom.
    var indexes = [index, newIndex].sort(function (a, b) { return a - b; }); // Sort the indixes
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
};
var moveUp = function (array, toMove) {
    move(array, toMove, -1);
};
exports.moveUp = moveUp;
var moveDown = function (array, toMove) {
    move(array, toMove, 1);
};
exports.moveDown = moveDown;
//# sourceMappingURL=array.js.map